import RecurringProphyStudy from './studyConfig/RecurringProphyStudy'

export default new RecurringProphyStudy({
  molecule: 'Erenumab',
  smallText: 'e.g. Aimovig',
  dosageOptions: [
    '70mg monthly',
    '140mg monthly'
  ]
})



// WEBPACK FOOTER //
// ./src/store/recurring/recurringProphyErenumab.js